import { Box, CircularProgress, Stack } from '@mui/material';
import Grid from '@mui/material/Grid';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import * as React from 'react';
import * as Redux from 'react-redux';
import { dateformat, formatDNI } from '../../../helpers';
import { getFilesArchivos } from '../../archivos/HelpersArchivos';
import { TEACHER_CONST } from '../../auth/login/LoginReducer';
import { allCarnetAction } from '../../carnet/CarnetAction';
import { captureElementToCanvasHelper } from '../../carnet/CarnetHelper';
import { ACTIVO_CARNET, PARAMS_CARNET } from '../../carnet/CarnetReducer';
import { ALTO_CARNET, ANCHO_CARNET, PDF_A4 } from '../../carnet/ConstCarnet';
import FrontalCarnet from '../../carnet/components/FrontalCarnet';
import LayoutCarnet from '../../carnet/components/LayoutCarnet';
import ReverseCarnet from '../../carnet/components/ReserveCarnet';
import BotonComponent from '../../dashboard/components/BotonNuevo';
import {
  fullnameCarnet,
  getFullnames,
} from '../estudiantes/TodosCarnetsEstudiantes';

const TodosCarnetsDocentes = () => {
  const dispatch = Redux.useDispatch();

  const docentesStore = Redux.useSelector((state) => state.docentes);
  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const carnetStore = Redux.useSelector((state) => state.carnet);

  const [loading, setLoading] = React.useState(false);
  const [tipoBoton, setTipoBoton] = React.useState(0);

  const [frontalRefs, setFrontalRef] = React.useState({});
  const [reverseRefs, setReverseRef] = React.useState({});
  const [qrRefs, setQrRef] = React.useState({});

  const ajustes = entidadesStore.ajustes;

  const values =
    docentesStore.selects.length > 0
      ? docentesStore.selects.filter((el) => el.usuario.perfil.avatar)
      : docentesStore.all.filter((el) => el.usuario.perfil.avatar);

  React.useEffect(() => {
    async function fetchData() {
      const payload = { idEntidad: entidadesStore.activo.id };
      dispatch({ type: PARAMS_CARNET, payload });
      const res = await allCarnetAction(dispatch, payload);

      // Buscar el diseño de carnet para docentes
      const docenteDiseno = res.data.find((el) => {
        const { perfil } = el;
        return perfil && perfil.rol === TEACHER_CONST;
      });

      if (res.data.length > 0) {
        dispatch({ type: ACTIVO_CARNET, payload: docenteDiseno });
      }
    }

    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // function getRol(value) {
  //   return rolesArray[value.usuario.rol].toUpperCase();
  // }

  const handleCompleto = async () => {
    setLoading(true);
    let doc = new jsPDF('portrait', 'pt', PDF_A4);
    let count = 0;
    try {
      for (const el of values) {
        if (el.usuario.perfil.avatar === null) continue;

        const canvasFront = await captureElementToCanvasHelper(
          frontalRefs[el.id],
        );
        const dataCanvaFront = canvasFront.toDataURL('image/jpg');

        const reverseRef = reverseRefs[`reversa${el.id}`];
        const canvasReverse = await html2canvas(reverseRef.current, {
          useCORS: true,
        });

        const dataCanvaReverse = canvasReverse.toDataURL('image/jpg');

        const x = 100;
        const y = 25 + count * 247.4;
        // const y = 25 + count * 253.5;

        doc.addImage(dataCanvaFront, 'JPEG', x, y, ANCHO_CARNET, ALTO_CARNET);
        doc.addImage(
          dataCanvaReverse,
          'JPEG',
          x + 160.4,
          y,
          ANCHO_CARNET,
          ALTO_CARNET,
        );

        count++;
        if (count === 3) {
          doc.addPage();
          count = 0;
        }
      }

      doc.save(`PDF-CARNET-DOCENTES-${values.length}.pdf`);
      setLoading(false);
      setTipoBoton(0);
    } catch (error) {
      setLoading(false);
      setTipoBoton(0);
    }
  };

  const handleSoloFront = async () => {
    setLoading(true);
    setTipoBoton(2);
    let doc = new jsPDF('portrait', 'pt', PDF_A4);

    let countRow = 0;
    let countColumn = 0;

    try {
      for (const el of values) {
        if (el.usuario.perfil.avatar === null) continue;

        const canvasFront = await captureElementToCanvasHelper(
          frontalRefs[el.id],
        );
        const dataCanvaFront = canvasFront.toDataURL('image/jpg');

        const x = 40 + countColumn * 157.31; // Ajusta el valor 150 según el espacio que necesites entre columnas
        const y = 25 + countRow * 247.82;

        doc.addImage(dataCanvaFront, 'JPEG', x, y, ANCHO_CARNET, ALTO_CARNET);

        countColumn++;
        if (countColumn === 3) {
          countColumn = 0;
          countRow++;
        }

        if (countRow === 3) {
          doc.addPage();
          countRow = 0;
        }
      }

      doc.save(`PDF-CARNET-SOLO-FRONTAL.pdf`);
      setLoading(false);
      setTipoBoton(0);
    } catch (error) {
      setLoading(false);
      setTipoBoton(0);
    }
  };

  const handleSoloQR = async () => {
    setLoading(true);
    setTipoBoton(3);
    let doc = new jsPDF('portrait', 'pt', PDF_A4);
    let countRow = 0;
    let countColumn = 0;

    try {
      for (const el of values) {
        if (el.usuario.codeqr === null) continue;

        const codeqrRef = qrRefs[`codeqr${el.id}`];
        if (!codeqrRef.current) continue;

        const canvasQR = await captureElementToCanvasHelper(codeqrRef.current);
        const dataCanvaQR = canvasQR.toDataURL('image/jpg');

        const x = 40 + countColumn * 130; // Ajusta el valor 5 según el margen que necesites
        const y = 25 + countRow * 145;

        doc.addImage(dataCanvaQR, 'JPEG', x + 7.5, y + 6.5, 115, 115);
        doc.rect(x, y, 130, 145); // Agrega un borde alrededor de la imagen
        doc.setFont('arial', 'bold');
        doc.setFontSize(9);
        doc.text(
          `${el.usuario.perfil.tipoDni}-${el.usuario.perfil.dni.trim()}`,
          x + 65,
          y + 131,
          'center',
        );
        doc.setFont('arial');
        doc.setFontSize(9);
        doc.text(
          el.usuario.perfil.pnombre.trim() +
            ' ' +
            el.usuario.perfil.papellido.trim(),
          x + 65,
          y + 140,
          'center',
        );

        countColumn++;
        if (countColumn === 4) {
          countColumn = 0;
          countRow++;
        }

        if (countRow === 5) {
          doc.addPage();
          countRow = 0;
        }
      }

      doc.save(`PDF-CODIGOS-QR.pdf`);
      setLoading(false);
      setTipoBoton(0);
    } catch (error) {
      setLoading(false);
      setTipoBoton(0);
    }
  };

  function setDataCanvas() {
    setLoading(true);
    for (const el of values) {
      setFrontalRef((prevState) => ({
        ...prevState,
        [el.id]: React.createRef(),
      }));
      setReverseRef((prevState) => ({
        ...prevState,
        [`reversa${el.id}`]: React.createRef(),
      }));
      setQrRef((prevState) => ({
        ...prevState,
        [`codeqr${el.id}`]: React.createRef(),
      }));
    }
    setLoading(false);
  }

  const botonFull = (
    <BotonComponent
      text="Carnets completo"
      click={async () => {
        setTipoBoton(1);
        if (Object.keys(frontalRefs).length === 0) {
          setDataCanvas();
          return;
        }

        await handleCompleto();
      }}
      disabled={loading}
      loading={loading && tipoBoton === 1}
      green={Object.keys(frontalRefs).length === 0}
      blue={Object.keys(frontalRefs).length > 0}
      mr={2}
    />
  );

  const botonSoloFrontal = (
    <BotonComponent
      text="Solo frontal"
      click={async () => {
        setTipoBoton(2);
        if (Object.keys(frontalRefs).length === 0) {
          setDataCanvas(2);
          return;
        }

        await handleSoloFront();
      }}
      disabled={loading}
      loading={loading && tipoBoton === 2}
      green={Object.keys(frontalRefs).length === 0}
      blue={Object.keys(frontalRefs).length > 0}
      mr={2}
    />
  );

  const botonSoloQR = (
    <BotonComponent
      text="Solo Código QR"
      click={async () => {
        setTipoBoton(3);
        if (Object.keys(qrRefs).length === 0) {
          setDataCanvas();
          return;
        }

        await handleSoloQR();
      }}
      disabled={loading}
      loading={loading && tipoBoton === 3}
      green={Object.keys(qrRefs).length === 0}
      blue={Object.keys(qrRefs).length > 0}
    />
  );

  if (!carnetStore.activo) {
    return <h3>Falta el diseños del carnet</h3>;
  }

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item sx={12} sm={12}>
          {botonFull}
          {botonSoloFrontal}
          {botonSoloQR}
          <br />
          <strong>Cantidad seleccionados:</strong> {values.length}
          {'   '}
          <strong>Total de hojas:</strong> {Math.ceil(values.length / 3)}
        </Grid>

        <Grid item sx={12} sm={12}>
          {carnetStore.loadingAll ? (
            <center>
              <CircularProgress size="3rem" sx={{ mt: 4 }} />
            </center>
          ) : (
            values.map((el) => {
              return (
                <div key={`carnet_${el.id}`} style={{ marginBottom: '30px' }}>
                  <Grid container spacing={2}>
                    <Grid
                      item
                      sx={12}
                      sm={3}
                      sx={{
                        display: 'flex',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                      }}
                    >
                      {fullnameCarnet(el.usuario)}
                    </Grid>
                    <Grid item sx={12} sm={9}>
                      <Stack direction="row" spacing={2} alignItems="center">
                        <LayoutCarnet
                          cardRef={frontalRefs[el.id]}
                          bg={getFilesArchivos(carnetStore.activo.fondo)}
                        >
                          <FrontalCarnet
                            notEdit
                            data={{
                              titleFullnameText: 'APELLIDOS Y NOMBRES',
                              photo: getFilesArchivos(
                                el.avatar ?? el.usuario.perfil.avatar,
                              ),
                              titleText: carnetStore.activo.titleText,
                              subtitleText: carnetStore.activo.subtitleText,
                              titleSeccionText:
                                carnetStore.activo.titleSeccionText,
                              titleNivelText: carnetStore.activo.titleNivelText,
                              ...getFullnames(el.usuario.perfil),
                              dni: `${el.usuario.perfil.tipoDni} - ${formatDNI(
                                el.usuario.perfil.dni.trim(),
                              )}`,
                              periodo: `PERÍODO ${ajustes.periodoAcademico.desde}-${ajustes.periodoAcademico.hasta}`,
                              // nivel,
                              // carrera,
                              profile: 'DOCENTE',
                              titleBackText: carnetStore.activo.titleBackText,
                              titleAgeText: carnetStore.activo.titleAgeText,
                              subtitleBackText:
                                carnetStore.activo.subtitleBackText,
                              age: dateformat(
                                el.usuario.perfil.fechaNacimiento,
                                { inverse: true },
                              ),
                            }}
                          />
                        </LayoutCarnet>
                        <LayoutCarnet
                          cardRef={reverseRefs[`reversa${el.id}`]}
                          bg={getFilesArchivos(carnetStore.activo.fondoBack)}
                          isReverse
                        >
                          <ReverseCarnet
                            qrRef={qrRefs[`codeqr${el.id}`]}
                            data={{
                              titleBackText: carnetStore.activo.titleBackText,
                              subtitleBackText:
                                carnetStore.activo.subtitleBackText,
                              titleFirmaText: carnetStore.activo.titleFirmaText,
                            }}
                            valueCodeqr={el.usuario.codeqr}
                            notEdit
                          />
                        </LayoutCarnet>
                      </Stack>
                    </Grid>
                  </Grid>
                </div>
              );
            })
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default TodosCarnetsDocentes;
